export const SESSION_KEYS = {
    SELECTED_SERVER_ID: 'selected_server_id',
    SELECT_FIRST_SERVER: 'select_first_server',
} as const;
